import Button from "@/components/Button";

export default function FinalCTA({ title }) {
  return (
    <section className="mt-20">
      <div className="rounded-[2.5rem] bg-slate-900 text-white px-6 py-12 ring-1 ring-slate-200/70 shadow-[0_18px_60px_-45px_rgba(15,23,42,0.6)] sm:px-10">
        <div className="flex flex-col items-start justify-between gap-6 lg:flex-row lg:items-center">
          <div>
            <span className="text-2xl font-semibold tracking-tight sm:text-3xl">
              {title || "Jetzt die passende Fotobox finden"}
            </span>
            <p className="mt-2 text-sm leading-6 text-slate-200 sm:text-base">
              Vergleiche Anbieter, Preise und Ausstattung – schnell und
              transparent.
            </p>
          </div>
          <div className="flex flex-wrap justify-end gap-3 text-center">
            <Button
              href="/fotobox-vergleich"
              variant="primary"
              className="w-full md:w-auto"
            >
              Vergleich starten
            </Button>
            <Button
              href="/fotobox-finder"
              variant="secondary"
              className="w-full md:w-auto"
              noFollow={true}
              noOpener={true}
              postToHrefOnSeo={true}
            >
              Fotobox-Finder starten
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
